import { render, staticRenderFns } from "./SaleForm.vue?vue&type=template&id=436a70b4&scoped=true&"
import script from "./SaleForm.vue?vue&type=script&lang=ts&"
export * from "./SaleForm.vue?vue&type=script&lang=ts&"
import style0 from "./SaleForm.vue?vue&type=style&index=0&id=436a70b4&lang=scss&scoped=true&"
import style1 from "./SaleForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436a70b4",
  null
  
)

export default component.exports